const FORMATION_DOCUMENT_TYPES = {
  CERTIFICATE_OF_INCORPORATION: {
    value: "certificate_of_incorporation",
    readableName: "Certificate of Incorporation",
  },
  CERTIFICATE_OF_FORMATION: {
    value: "certificate_of_formation",
    readableName: "Certificate of Formation",
  },
  CERTIFICATE_OF_FORMATION_PARTNERSHIP: {
    value: "certificate_of_formation_partnership",
    readableName: "Certificate of Formation/Partnership",
  },
  LIMITED_PARTNERSHIP_OPERATING_AGREEMENT: {
    value: "limited_partnership_operating_agreement",
    readableName: "Limited Partnership Operating Agreement",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

// Convert the object to an array of entries
export const formationDocumentTypesArray = Object.values(FORMATION_DOCUMENT_TYPES);
